import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
export default {
  props: {
    checkExpectedDeliveryDate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showExpectedDeliveryDatePrompt: false,
    }
  },
  computed: {
    ...mapState('user', ['dealerSettings']),
    ...mapGetters({
      expectedDeliveryDates: 'quote/expectedDeliveryDates',
      deliveryDate: 'quote/deliveryDate',
      isStockCar: 'quote/isStockCar',
    }),
    expectedDeliveryDatesEnabled() {
      return this.dealerSettings.showDeliveryDates
    },
    expectedDeliveryDateCustomer() {
      return this.expectedDeliveryDates?.ExpectedDeliveryDateCustomer
    },
    expectedDeliveryDateUnknown() {
      let allDatesSame = true
      if (!!this.expectedDeliveryDates) {
        const expectedDeliveryDateValues = Object.values(this.expectedDeliveryDates)
        let i = 1
        while (allDatesSame && i < expectedDeliveryDateValues.length) {
          allDatesSame = moment
            .utc(expectedDeliveryDateValues[i])
            .isSame(moment.utc(expectedDeliveryDateValues[i - 1]), 'day')
          i++
        }
      }

      return allDatesSame
    },
    expectedDeliveryDateUnknownAndForced() {
      return (
        this.expectedDeliveryDateUnknown &&
        this.dealerSettings.showDeliveryDates &&
        !this.isStockCar
      )
    },
  },
  methods: {
    expectedDeliveryDateCheck(forceLiBKnown) {
      if (this.checkExpectedDeliveryDate && this.expectedDeliveryDatesEnabled) {
        if (
          this.deliveryDateLessThanExpected() ||
          (forceLiBKnown && this.expectedDeliveryDateUnknownAndForced)
        ) {
          this.showExpectedDeliveryDatePrompt = true
          return false
        }
      }
      return true
    },
    deliveryDateLessThanExpected() {
      return moment
        .utc(this.deliveryDate)
        .isBefore(moment.utc(this.expectedDeliveryDateCustomer), 'day')
    },
  },
}
